import { BASE_URL, CANDIDATE_KEYWORD_SUGGESTION, PUBLIC } from "../../common/URLs"

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${CANDIDATE_KEYWORD_SUGGESTION}?keyword=`; 

export const fetchSuggestions = async (keyword) => {
  const url = `${API_BASE_URL}${keyword}`; 
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response sugg", response)
    const data = await response.json();
    return data;
  } catch (error) { 
    console.log("error", error);
  }
};